import React, { useState, useEffect, useRef } from 'react';
// @ts-ignore
import ReactDOM from 'react-dom';
import cn from 'classnames';
// @ts-ignore
import { useTranslation } from 'react-i18next';
import Icon from 'tbk-components/src/components/Icon';

const BlogRollFilterBar = (props: any) => {
	const [state, updateState] = useState<any>({ open: {} });
	const { t } = useTranslation();
	const { onChange = (a: any) => {}, assets = {}, targetUrl = null } = props;
	const ref = useRef(null);
	const toggleFilter = (key: any) => {
		updateState((s: any) => ({
			...s,
			open: {
				...s.open,
				[key]: !s.open[key],
			},
		}));
	};
	const taxonomies = assets.taxonomies || [];
	const filters = { ...(props.filters || {}) };
	let activeCount = filters.search ? 1 : 0;
	const clearedState: any = {
		search: null,
		page: 1,
	};
	taxonomies.forEach((taxonomy: any) => {
		if (!filters[taxonomy.taxonomy]) {
			filters[taxonomy.taxonomy] = [];
		}
		activeCount += filters[taxonomy.taxonomy].length;
		clearedState[taxonomy.taxonomy] = [];
	});
	const onCheckFilter = (e: any) => {
		const input = e.target;
		const taxonomy = input.name;
		const index = filters[taxonomy].indexOf(input.value);
		if (input.checked) {
			if (index === -1) {
				filters[taxonomy].push(input.value);
			}
		} else if (index !== -1) {
			filters[taxonomy].splice(index, 1);
		}
		onChange({
			[taxonomy]: filters[taxonomy],
			page: 1,
		});
	};

	useEffect(() => {
		const header = document.querySelector(
			'.subpage-header',
		) as HTMLDivElement;
		const filtersSummary = document.querySelector('.filter-summary');

		if (!header) {
			return;
		}

		if (filtersSummary) {
			header.style.marginTop = `${filtersSummary.clientHeight - 1}px`;
		} else {
			header.style.marginTop = '0';
		}
	}, [window.location.hash]);

	const el = document.getElementById('blogroll-filters');
	const content = (
		<>
			<div className="blogroll-filter-bar" ref={ref}>
				<form
					onSubmit={(e) => e.preventDefault()}
					className="filter-container"
				>
					<div className="filter-item search-wrapper full-width">
						<div className="search">
							<label htmlFor="filter-search" className="visually-hidden">
								{t('Filter Search')}
							</label>
							<input
								name="search"
								type="text"
								id="filter-search"
								className="search__input"
								placeholder={t(props.SearchPlaceholder || 'Search')}
								value={filters.search || ''}
								aria-label={t('Search')}
								onChange={(e) =>
									onChange({
										search: e.target.value,
										page: 1,
									})}
							/>
							<button
								type="submit"
								aria-label={t('submit search')}
								className="search__btn"
							>
								<Icon name="search" />
							</button>
						</div>
					</div>
					{targetUrl && (
						<div className="filter-go-btn">
							<a className="btn btn-primary btn-sm" href={targetUrl}>
								{t('Go')}
							</a>
						</div>
					)}
				</form>
			</div>
			<div className="blogroll-filter-checkboxes">
				{taxonomies.map((taxonomy: any) => (
					<div
						key={taxonomy.taxonomy}
						className={`filter-checkboxes filter-checkboxes__${taxonomy.taxonomy}`}
					>
						<span className="filter-label">Select {taxonomy.label}:</span>
						{taxonomy.terms.map((term: any) => (
							<div className="form-check" key={term.term_id}>
								<input
									id={
										term.name
											.replace(/\s+/g, '-')
											.toLowerCase() + term.term_id
									}
									className="form-check-input"
									type="checkbox"
									defaultValue={term.term_id}
									checked={
										filters[taxonomy.taxonomy].indexOf(
											`${term.term_id}`,
										) !== -1
									}
									name={taxonomy.taxonomy}
									onChange={onCheckFilter}
								/>
								<label
									className="form-check-label"
									htmlFor={
										term.name
											.replace(/\s+/g, '-')
											.toLowerCase() + term.term_id
									}
									key={term.term_id}
								>
									{term.name}
								</label>
							</div>
						))}
					</div>
				))}
			</div>
		</>
	);

	return el ? ReactDOM.createPortal(content, el) : content;
};

export default BlogRollFilterBar;
